import React from "react";
import { Button, Spinner } from "react-bootstrap";
import styled from "styled-components";
import { colors } from "utils";

const Bar = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
`;

const RunButton = styled(Button)`
  background-color: ${colors.nightlyWoods500};
  border: none;
`;

export const ReportToolbar = ({
  validation,
  loading,
  downloading,
  onRun,
  onDownload,
}) => (
  <Bar>
    <RunButton onClick={onRun} disabled={!validation.ok || loading}>
      {loading ? (
        <>
          <Spinner animation="border" size="sm" /> Running...
        </>
      ) : (
        "Run report"
      )}
    </RunButton>
    <Button
      variant="outline-secondary"
      onClick={onDownload}
      disabled={!validation.ok || downloading}
    >
      {downloading ? "Downloading..." : "Download CSV"}
    </Button>
    {!validation.ok && validation.message && (
      <span style={{ color: colors.nightlyWoods700 || "#6B7280", fontSize: 13 }}>
        {validation.message}
      </span>
    )}
  </Bar>
);
